export enum ImageStatus {
    LOADING,
    SUCCESS,
    ERROR
}

export type ValidationResponse = {status: ImageStatus.LOADING | ImageStatus.SUCCESS | ImageStatus.ERROR};

export const imageValidation = (src: string) => {
    return new Promise<ValidationResponse>((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve({status: ImageStatus.SUCCESS});
        img.onerror = () => reject({status: ImageStatus.ERROR});

        img.src = src;
    });
};
export enum ImageStatus {
    LOADING,
    SUCCESS,
    ERROR
}

export type ValidationResponse = {status: ImageStatus.LOADING | ImageStatus.SUCCESS | ImageStatus.ERROR};

export const imageValidation = (src: string) => {
    return new Promise<ValidationResponse>((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve({status: ImageStatus.SUCCESS});
        img.onerror = () => reject({status: ImageStatus.ERROR});

        img.src = src;
    });
};
